import { useEffect } from "react";
import useLedger from "../atoms/useLedgerAtom";
import useSplitPaymentHook from "./useSplitPaymentHook";

const useHandleLedger = () => {
  const [ledger, setLedger] = useLedger();
  const { updateLedger, onSuccessPayment } = useSplitPaymentHook();

  useEffect(() => {
    if (ledger) {
      const newLedgers = updateLedger(ledger.item_id, ledger);
      onSuccessPayment(ledger, newLedgers);
      setLedger(null); // Reset ledgerId after handling
    }
  }, [ledger]);
};

export default useHandleLedger;
